<div class="offers-comparison-coverages-group">
    <div class="offers-comparison-coverages-group__header">
        <span>{{ coveragesGroup.label }}</span>
    </div>
    <div class="offers-comparison-coverages-group__coverages">
        <ng-container *ngFor="let coverage of coveragesGroup.coverages">
            <div *ngIf="coverage.label"
                 class="offers-comparison-coverages-group__coverage">
                <div class="next-offers-comparison-dialog__left-col offers-comparison-coverages-group__coverage__label">
                    <span [innerHTML]="coverage.label | translate | safeHtml"></span>
                    <app-tooltip-icon *ngIf="coverage.tooltip"
                                      [outlined]="true"
                                      [description]="coverage.tooltip">
                    </app-tooltip-icon>
                </div>
                <div class="next-offers-comparison-dialog__right-col">
                    <div *ngFor="let offer of offers"
                         class="next-offers-comparison-dialog__right-col__cell">
                        <app-offer-compare-box [box]="offerCoveragesService.getCoverageDestiny(offer, coverage.code, 'COMPARE')"
                                               [coverageCode]="coverage.code">
                        </app-offer-compare-box>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</div>
